import React, { useState } from "react";
import {
    SovosBox,
    SovosButton,
    SovosDialog,
    SovosDialogActions,
    SovosDialogContent,
    SovosDialogTitle,
    SovosSelect,
    SovosMenuItem,
    SovosTypography,
    SovosLinearProgress,
} from "mosaic-react";
import { Download, InfoOutlined } from "mosaic-react-icons";
import { connect } from "react-redux";

const DatagridMultipleDownloadDialog = (props) => {
    const { data, i18n, cancel, downloading } = props;
    const { queries, download, locale, downloadCsvStreamAction, showCsvOption = false } = data;
    const [downloadEntity, setDownloadEntity] = useState(queries?.[0]["exportableEntity"] || "");
    const [fileFormat, setFileFormat] = useState("xlsx");

    const entityOptions = queries.reduce((acc, { resource, exportableEntity }) => {
        const entity = `${resource}${exportableEntity}`;
        acc.push({ label: i18n`${entity}`, value: exportableEntity });
        return acc;
    }, []);

    const fileFormatOptions = [
        { label: i18n`XLSX (Excel)`, value: "xlsx" },
        { label: i18n`CSV`, value: "csv" },
    ];

    const handleEntityChange = (e) => {
        setDownloadEntity(e.target.value);
    };

    const handleFileFormatChange = (e) => {
        setFileFormat(e.target.value);
    };

    const handleConfirm = () => {
        const entityToDownload =
            queries?.length &&
            queries.find((elem) => elem.exportableEntity === downloadEntity);
        if (entityToDownload) {
            entityToDownload.args.selectedExportableOption = downloadEntity;
        }

        // Only use CSV if showCsvOption is true and CSV is selected
        if (showCsvOption && fileFormat === "csv") {
            downloadCsvStreamAction && downloadCsvStreamAction([entityToDownload], locale);
        } else {
            download && download([entityToDownload], locale, null);
        }
        cancel && cancel();
    };

    return (
        <SovosDialog open={true} maxWidth="sm" fullWidth>
            {downloading ? (
                <SovosBox
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(255, 255, 255, 0.9)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1,
                    }}
                >
                    <SovosLinearProgress sx={{ width: "150px", mb: 2 }} />
                    <SovosTypography>{i18n`Downloading...`}</SovosTypography>
                </SovosBox>
            ) : null}
            <SovosDialogTitle
                showCloseButton
                onClose={() => {
                    cancel && cancel();
                }}
            >
                {i18n`Download Data`}
            </SovosDialogTitle>
            <SovosDialogContent>
                <SovosTypography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    {showCsvOption 
                        ? i18n`Choose the file format and data type to download.`
                        : i18n`Choose the data type to download.`
                    }
                </SovosTypography>

                {showCsvOption && (
                    <SovosSelect
                        label={i18n`Choose file format`}
                        value={fileFormat}
                        onChange={handleFileFormatChange}
                        fullWidth
                        sx={{ mb: 3 }}
                    >
                        {fileFormatOptions.map((option) => (
                            <SovosMenuItem key={option.value} value={option.value}>
                                {option.label}
                            </SovosMenuItem>
                        ))}
                    </SovosSelect>
                )}

                <SovosSelect
                    label={i18n`Choose data type`}
                    value={downloadEntity}
                    onChange={handleEntityChange}
                    fullWidth
                >
                    {entityOptions.map((option) => (
                        <SovosMenuItem key={option.value} value={option.value}>
                            {option.label}
                        </SovosMenuItem>
                    ))}
                </SovosSelect>
            </SovosDialogContent>
            <SovosDialogActions>
                <SovosBox sx={{ width: "100%" }}>
                    <SovosBox sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
                        <SovosButton
                            variant="text"
                            onClick={() => {
                                cancel && cancel();
                            }}
                        >
                            {i18n`Cancel`}
                        </SovosButton>
                        <SovosButton 
                            variant="contained"
                            startIcon={<Download />}
                            onClick={handleConfirm}
                        >
                            {i18n`Download`}
                        </SovosButton>
                    </SovosBox>
                    {/* Show warning only when XLSX is selected (or when no CSV option available) */}
                    {(fileFormat === "xlsx" || !showCsvOption) && (
                        <SovosBox
                            sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
                        >
                            <InfoOutlined sx={{ marginRight: "8px", color: "text.secondary" }} />
                            <SovosTypography variant="body2" color="text.secondary">
                                {i18n`Limit of 120000 rows per file`}
                            </SovosTypography>
                        </SovosBox>
                    )}
                </SovosBox>
            </SovosDialogActions>
        </SovosDialog>
    );
};

export default connect(({ downloading }) => ({ downloading }), {})(DatagridMultipleDownloadDialog);
